var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ai-requests-card',{staticClass:"mb-3"}),_c('ai-requests-info-text',{attrs:{"text":_vm.$t('aiAssistancePage.yourAiAssistanceCredit')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }